import Vue from 'vue'
import Main from './main'

const msgbox = Vue.extend(Main)

export default {
  msgbox: ({ info, visible, callback=()=>{}, close=()=>{} }) => {
    let dom = new msgbox({
      el: document.createElement('div'),
      data() {
        return {
          info: info,
          visible: visible,
          callback: callback,
          close: close
        }
      },
      methods: {
        handleClose() {
          this.visible = false
          document.body.removeChild(dom.$el)
        },
        handleCancel() {
          this.handleClose()
          this.close()
        },
        handleSubmit() {
          this.handleClose()
          this.callback(this.info)
        }
      }
    })
    document.body.appendChild(dom.$el)
  }
}